import {useMutation} from 'react-query';
import {useEffect, useRef, useState} from 'react';
import {Navigate, Outlet, useLocation, useNavigate} from 'react-router-dom';
import {EXTERNAL_PROVIDE} from '../config/cacheKey';
import {getJwtToken, setJwtToken} from '../services/auth.service';
import {ExternalAccountLogin} from '../services/externalAccount.service';
import PWASplash from '../layouts/_core/pwaSplash';

export default function RouteWithState() {
    const navigate = useNavigate();
    const location = useLocation();
    const [entry] = useState(() => {
        const url = new URL(window.location.href);
        return url.pathname.replace(/\/+$/, '') === '/kaman'
            ? url.searchParams.get('token')
            : null;
    });
    const [entryPending, setEntryPending] = useState(!!entry);
    const started = useRef(false);
    const {mutate: externalLogin} = useMutation(ExternalAccountLogin, {
        onSuccess: (result) => {
            if (!result.isSuccess || !result.data?.jwt) {
                navigate('/externalRoute', {replace: true});
                return;
            }
            setJwtToken(result.data.jwt, result.data.refreshToken);
            // Preserve target and loanTemplateKey for the destination handlers.
            // Consume the entry token/path to prevent login on later remounts.
            const url = new URL(window.location.href);
            url.searchParams.delete('token');
            const search = url.searchParams.toString();
            window.history.replaceState(
                window.history.state,
                '',
                `/${search ? `?${search}` : ''}${url.hash}`
            );
            setEntryPending(false);
            navigate('/home', {replace: true});
        },
        onError: () => navigate('/externalRoute', {replace: true}),
    });

    useEffect(() => {
        if (!entry || started.current) return;
        started.current = true;
        sessionStorage.setItem(EXTERNAL_PROVIDE, 'externalProvider');
        externalLogin({loginProvider: 'Kaman', externalToken: entry});
    }, [entry, externalLogin]);

    if (entryPending) return <PWASplash> </PWASplash>;
    if (getJwtToken().token) return <Outlet />;
    return <Navigate to="/login" replace state={{from: location}} />;
}
